module.exports = __webpack_public_path__ + "static/media/report-search.2858b1cc.svg";